"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._translate = exports._getResource = exports._Translator = exports._Security = exports._Notifications = exports._Logger = exports._Environment = exports._Api = exports.ContextCore = void 0;
var _index = _interopRequireWildcard(require("wever-core/dist/services/translator/index"));
var _resources = _interopRequireDefault(require("wever-core/dist/services/resources"));
var _security = _interopRequireDefault(require("wever-core/dist/services/security"));
var _api = _interopRequireDefault(require("wever-core/dist/services/api"));
var _logger = _interopRequireDefault(require("wever-core/dist/services/logger"));
var _notifications = _interopRequireDefault(require("wever-core/dist/services/notifications"));
var _context = _interopRequireDefault(require("wever-core/dist/services/context"));
var _environment = _interopRequireDefault(require("wever-core/dist/services/environment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Ce fichier permet de faire la liaison entre le wever-core et l'apps

/*
 * S'il manque quelques de wever-core, vous pourrez l'ajouter ici.
 */

// traduction => _translate('clé de traduction')
const _translate = exports._translate = _index.t;
// traduction service
const _Translator = exports._Translator = _index.default;
// Permet d'obtenir les données api pour une entité _getResource('User').read()
const _getResource = exports._getResource = _resources.default;
// Permet de faire des appels Api "direct" en utilisant une url. (_Api.read(<url>), _Api.create(<url>, <data>))
const _Api = exports._Api = _api.default;
// Permet de savoir si l'utilisateur est authentifié, si son role est bon etc.
const _Security = exports._Security = _security.default;
// Permet de faire des notifications : Notif.{info, success, error, warning}
const _Notifications = exports._Notifications = _notifications.default;
// Permet de logger (en mode dev) dans la console. Logger.{info, success, warn, error}
const _Logger = exports._Logger = _logger.default;
const ContextCore = exports.ContextCore = _context.default;
const _Environment = exports._Environment = _environment.default;
const DefaultObject = {
  _translate,
  _getResource,
  _Security,
  _Api,
  _Notifications,
  _Logger,
  _Translator,
  _Environment,
  ContextCore
};
var _default = exports.default = DefaultObject;